import React from 'react'
import { Mutation } from "react-apollo";
import SitesForm from "../components/form";
import { ADD, GET } from "../../../queries/site";

const Add = (props) => {
  return (
    <Mutation
      mutation={ADD}
      update={(store, { data: { createSite } }) => {
        const { sites } = store.readQuery({ query: GET });
        store.writeQuery({
          query: GET,
          data: { sites: sites.concat([createSite]) }
        });
      }}
      >
        
      {createSite => (
       <SitesForm query_f = {createSite} {...props}/>
      )}
    </Mutation>
  );
};

export default Add;